import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import Menubar from "../Menubar"; import { store } from "../../App"; import ShowAlert from "../alert";
import MasterService from "../../Services/MasterService"; import SwaranandhraService from "../../Services/SwaranandhraService"; import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai"; import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable"; import jsPDF from "jspdf"; import { Row, Col, Button, Container, Table } from 'react-bootstrap';
import { exportToExcel} from "../utils/commonFunctions"; import { Link } from "@mui/material";

const IndicatorBasedTarget=()=> {

const [search, setSearch] = useState("");const [MainEnble, setMainEnble] = useState(false);  const [DistEnble, setDistEnble] = useState(false);const [data, setData] = useState(); const [distlist, setDistrictList] = useState([]);  const [data1, setData1] = useState(); const [SubEnablemandal, setSubEnablemandal] = useState(false); const [search1, setSearch1] = useState(""); const [DistrictName, setDistrictName] = useState([]); const [mandalName, setmandalName] = useState([]);

  let username = localStorage.getItem("username");
  let role = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");

  const formik = useFormik({ initialValues: { district_id: "" }, })

  React.useEffect(() => {
    if ((role === "2") || (role === "10" || role === "3")) { setDistEnble(true) }
    if (role === "5") { setDistEnble(false) } formik.setFieldValue("district_id", district !== "0" ? district : ""); }, [])

  const fetchgetdata = (payload) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getTargetWiseindicatorReport(payload).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setData1(res.data.SDESC)
        const uniquemandalName = [...new Set(res.data.SDESC.map(item => item.mandal_name))];
        setmandalName(uniquemandalName); setMainEnble(false); setSubEnablemandal(true);
      }
    }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
  }

  useEffect(() => {
    MasterService.getDistricts().then((resp) => { if (resp.data) { let options = resp.data.map((item, i) => { return ( <option key={item.id} value={item.id}> {item.value} </option> ); }); setDistrictList(options); } }); if (role === "10" || role === "2") { let payload = { "userId": username, "districtId": district }; fetchgetdata(payload); }

  }, []);





  const fetchSubdata = (district_id) => {
    formik.setFieldValue("district_id", district_id); let payload1 = { "userId": username, "districtId": district_id, }; fetchgetdata(payload1);
  }




  const fetchAdmindata = (e) => {
    formik.setFieldValue("district_id", e.target.value)
    if ((role === "5" || role === "8") && (e.target.value !== "" && e.target.value !== undefined)) {
      let payload = { "districtId": e.target.value === "0" ? null : e.target.value, "userId": username, }
      if (e.target.value !== "0") { fetchgetdata(payload); }
      else if (e.target.value === "0") {
        store.dispatch({ type: "SHOW_SPINNER" });
        SwaranandhraService.getTargetWiseindicatorReport(payload).then((res) => {
          if (res.data && res.data.SCODE === "01") { setData(res.data.SDESC); const uniqueDistrictName = [...new Set(res.data.SDESC.map(item => item.district_name))]; setDistrictName(uniqueDistrictName); }
          setMainEnble(true); setSubEnablemandal(false);
        }).catch((err) => { ShowAlert(err, "error"); }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); })
      }
    }
  }

  function fetchgeneratePdf(tableid) {
    const doc = new jsPDF({ 
      orientation: "portrait",
      unit: "mm",
      format:[4000,4000]
   } );
    autoTable(doc, { html: tableid, theme: "grid", tableWidth: 'wrap', columnStyles: { 3: { cellWidth: "wrap" } }, headStyles: { halign: "center" }, styles: { fontSize: 8 }, });
    doc.save("Indicator Wise Targets Report.pdf");
  }

  const fetchfilteredData =
    search.length > 0 ? data?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(search.toLowerCase())); }) ); }) : data;


  const fetchfilteredData1 =
    search1.length > 0 ? data1?.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return (value !== null && value.toString().toLowerCase().includes(search1.toLowerCase())); }) ); }) : data1;



  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "80%" }}>
        <div className='sa-title'>
          <h2>Indicatorwise Targets <span>Report</span></h2>
        </div>
      </Container>

      <Container fluid style={{ width: "80%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4 mt-2'>
              <Row>
                <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className="mx-4" >
                  <label htmlFor="district_id" className="mb-1 fw-bold"> DISTRICT </label> <span style={{ color: "red" }}> *</span>
                  <Field component="select" name="district_id" disabled={DistEnble} className="form-control" value={formik.values.district_id} onChange={(e) => { fetchAdmindata(e) }} > <option value="">--Select--</option> <option value="0">All</option> {distlist} </Field>
                  <span style={{ color: "red", fontSize: "13px" }}> <ErrorMessage name="district_id" /> </span>
                </Col>

              </Row>
            </div>

          </Form>
        </FormikProvider><br />


        {MainEnble &&
          <>
            <Row>
              <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className="mb-3" >
                <div className="input-group">
                  <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                  <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch(event.target.value)} />
                </div>
              </Col>

              <Col xs={12} sm={12} md={9} lg={9} xl={9} xxl={9} className=" mb-2 float-end" >
                <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={() => { fetchgeneratePdf("#my-table") }} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /> </Button>
                <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "Indicator Wise Targets Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </Button>
              </Col>
            </Row>
            <div id="table-scroll" className="table-scroll">
              <div className="table-wrap">
                <Table
                  id="my-table"
                  className="table table-bordered custom-table table-responsive sticky-table"
                >
                  <thead>
                    <tr>
                      <th className="sticky-col sticky-sno" rowSpan={2}>Sl.No.</th>
                      <th className="sticky-col sticky-indicator" rowSpan={2}>Sector Name</th>
                      <th className="sticky-col sticky-subindicator" rowSpan={2}>Indicator Name</th>
                      <th className="sticky-col sticky-phase1unit" rowSpan={2}>Unit</th>
                      {DistrictName.map((district1) => ( <th key={district1} colSpan={5} style={{ textAlign: "center" }}>{district1}</th> ))}
                      <th colSpan={5} style={{ textAlign: "center" }}>Totals</th>
                    </tr>
                    <tr> {DistrictName.map((district1, index) => ( <> <th key={`target-2024-2025-${index}`}>Target 2024-2025</th> <th key={`target-2025-2026-${index}`}>Target 2025-2026</th> <th key={`target-2026-2027-${index}`}>Target 2026-2027</th> <th key={`target-2027-2028-${index}`}>Target 2027-2028</th> <th key={`target-2028-2029-${index}`}>Target 2028-2029</th> </> ))}
                      <th>Target 2024-2025</th> <th>Target 2025-2026</th> <th>Target 2026-2027</th> <th>Target 2027-2028</th> <th>Target 2028-2029</th> </tr>
                  </thead>
                  <tbody>
                    {fetchfilteredData?.length === 0 || fetchfilteredData === undefined ? ( <tr> <td colSpan={DistrictName.length * 5 + 9} className="text-center" style={{ color: "red" }}> Details Not Found </td> </tr>
                    ) : (
                      fetchfilteredData?.reduce((acc, detail) => {
                        const existingRow = acc.find(item => item.indicator_name === detail.indicator_name && item.sub_indicator_name === detail.sub_indicator_name);

                        if (!existingRow) {
                          acc.push({ indicator_name: detail.indicator_name, sub_indicator_name: detail.sub_indicator_name, unit: detail.unit, districtData: { [detail.district_name]: { district_code: detail.district_code, targets: { target_2024_2025: detail.target_2024_2025 || 0, target_2025_2026: detail.target_2025_2026 || 0, target_2026_2027: detail.target_2026_2027 || 0, target_2027_2028: detail.target_2027_2028 || 0, target_2028_2029: detail.target_2028_2029 || 0, }, }, },
                            sub_indicator_id: detail.sub_indicator_id, 
                          });
                        } 
                        else { existingRow.districtData[detail.district_name] = { district_code: detail.district_code, targets: { target_2024_2025: detail.target_2024_2025 || 0, target_2025_2026: detail.target_2025_2026 || 0, target_2026_2027: detail.target_2026_2027 || 0, target_2027_2028: detail.target_2027_2028 || 0, target_2028_2029: detail.target_2028_2029 || 0, }, }; }

                        return acc;
                      }, []).map((row, index) => {
                        const totalCounts = { target_2024_2025: 0, target_2025_2026: 0, target_2026_2027: 0, target_2027_2028: 0, target_2028_2029: 0, };

                        const totalTargets = DistrictName.reduce((totals, district8) => { const targets = row.districtData[district8]?.targets; if (targets) { Object.keys(totals).forEach(targetKey => { if (targets[targetKey] > 0) { totals[targetKey] += targets[targetKey]; totalCounts[targetKey] += 1; } }); } return totals;
                        }, { target_2024_2025: 0, target_2025_2026: 0, target_2026_2027: 0, target_2027_2028: 0, target_2028_2029: 0, });

                        if ([26, 27, 24, 29, 21, 30, 25, 20, 28, 22, 23, 120].includes(row.sub_indicator_id)) { Object.keys(totalTargets).forEach(key => { if (totalCounts[key] > 0) { totalTargets[key] /= totalCounts[key]; } }); }

                        const isFirstOccurrence = index === 0 || row.indicator_name !== fetchfilteredData[index - 1].indicator_name;

                        return (
                          <tr key={index}>
                            <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
                            <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.indicator_name : ''}</td>
                            <td style={{ minWidth: "200px", wordWrap: "break-word", whiteSpace: "normal", textAlign: "left" }} className="sticky-col sticky-subindicator">
                              {row.sub_indicator_name}</td>
                            <td style={{ textAlign: "center" }} className="sticky-col sticky-phase1unit">{row.unit}</td>

                            {DistrictName.map((district4, i) => (
                              <>
                                <td key={`target-2024-2025-${district4}-${index}`} className="text-right">
                                  <Link onClick={() => fetchSubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}> {row.districtData[district4]?.targets.target_2024_2025} </Link>
                                </td>

                                <td key={`target-2025-2026-${district4}-${index}`} className="text-right">
                                  <Link onClick={() => fetchSubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}> {row.districtData[district4]?.targets.target_2025_2026} </Link>
                                </td>

                                <td key={`target-2026-2027-${district4}-${index}`} className="text-right">
                                  <Link onClick={() => fetchSubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}> {row.districtData[district4]?.targets.target_2026_2027} </Link>
                                </td>

                                <td key={`target-2027-2028-${district4}-${index}`} className="text-right">
                                  <Link onClick={() => fetchSubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}> {row.districtData[district4]?.targets.target_2027_2028} </Link>
                                </td>

                                <td key={`target-2028-2029-${district4}-${index}`} className="text-right">
                                  <Link onClick={() => fetchSubdata(row.districtData[district4].district_code)} style={{ cursor: "pointer", color: "blue", textDecoration: "none" }}> {row.districtData[district4]?.targets.target_2028_2029} </Link>
                                </td>
                              </>
                            ))}

                            <td className="text-right">{totalTargets.target_2024_2025.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2025_2026.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2026_2027.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2027_2028.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2028_2029.toFixed(2)}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>

                </Table>




              </div>
            </div>
          </>
        }



        {SubEnablemandal && <>
          <Row  >
            <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-2" style={{ marginLeft: "40px" }}>
              <div className="input-group">
                <div className="input-group-prepend"> <div className="input-group-text group_txt11" id="btnGroupAddon" > <AiOutlineSearch /> </div> </div>
                <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearch1(event.target.value)} />
              </div>
            </Col>

            <Col xs={12} sm={12} md={4} lg={4} xl={4} xxl={4} className=" mb-2 float-center" >
              <Button variant="danger" size="sm" className="btn mx-2 pdf-btn" onClick={() => { fetchgeneratePdf("#my-table1") }} style={{ float: "right", marginLeft: "3px" }} >PDF<MdOutlinePictureAsPdf /> </Button>
              <Button variant="success" size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table1", "Indicator Wise Targets Report")} > Excel<AiFillFileExcel style={{ fontSize: "18px" }} /> </Button>
            </Col>

          </Row>
          <div id="table-scroll" className="table-scroll" >
            <div className="table-wrap">
              <Table
                id="my-table1"
                className="table table-bordered custom-table table-responsive sticky-table"
              >
                <thead>
                  <tr>
                    <th className="sticky-col sticky-sno" rowSpan={2}>Sl.No.</th>
                    <th className="sticky-col sticky-indicator" rowSpan={2}>Sector Name</th>
                    <th className="sticky-col sticky-subindicator" rowSpan={2}>Indicator Name</th>
                    <th className="sticky-col sticky-phase1unit" rowSpan={2}>Unit</th>
                    {mandalName.map((mandal) => (
                      <th key={mandal} colSpan={5} style={{ textAlign: "center" }}>{mandal}</th>
                    ))}
                    <th colSpan={5} style={{ textAlign: "center" }}>Totals</th>
                  </tr>
                  <tr>
                    {mandalName.map((mandal, index) => ( <> <th key={`target-2024-2025-${index}`}>2024-2025</th> <th key={`target-2025-2026-${index}`}>2025-2026</th> <th key={`target-2026-2027-${index}`}>2026-2027</th> <th key={`target-2027-2028-${index}`}>2027-2028</th> <th key={`target-2028-2029-${index}`}>2028-2029</th> </> ))}
                    <th>2024-2025</th> <th>2025-2026</th> <th>2026-2027</th> <th>2027-2028</th> <th>2028-2029</th>
                  </tr>
                </thead>
                <tbody>
                  {fetchfilteredData1?.length === 0 || fetchfilteredData1 === undefined ? ( <tr> <td colSpan={mandalName.length * 5 + 9} className="text-center" style={{ color: "red" }}> Details Not Found </td> </tr> ) : (
                    fetchfilteredData1?.reduce((acc, detail) => {
                      const existingRow = acc.find(item => item.indicator_name === detail.indicator_name && item.sub_indicator_name === detail.sub_indicator_name);

                      if (!existingRow) {
                        acc.push({ indicator_name: detail.indicator_name, sub_indicator_name: detail.sub_indicator_name, unit: detail.unit, mandalData: { [detail.mandal_name]: { mandal_code: detail.mandal_code, targets: { target_2024_2025: detail.target_2024_2025 || 0, target_2025_2026: detail.target_2025_2026 || 0, target_2026_2027: detail.target_2026_2027 || 0, target_2027_2028: detail.target_2027_2028 || 0, target_2028_2029: detail.target_2028_2029 || 0, }, }, }, sub_indicator_id: detail.sub_indicator_id, });
                      } else {
                        existingRow.mandalData[detail.mandal_name] = { mandal_code: detail.mandal_code, targets: { target_2024_2025: detail.target_2024_2025 || 0, target_2025_2026: detail.target_2025_2026 || 0, target_2026_2027: detail.target_2026_2027 || 0, target_2027_2028: detail.target_2027_2028 || 0, target_2028_2029: detail.target_2028_2029 || 0, }, };
                      }

                      return acc;
                    }, []).map((row, index) => {
                      const totalCounts = { target_2024_2025: 0, target_2025_2026: 0, target_2026_2027: 0, target_2027_2028: 0, target_2028_2029: 0, };

                      const totalTargets = { target_2024_2025: 0, target_2025_2026: 0, target_2026_2027: 0, target_2027_2028: 0, target_2028_2029: 0, };

                      mandalName.forEach(mandal => {
                        const targets = row.mandalData[mandal]?.targets;

                        if (targets) { Object.entries(targets).forEach(([targetKey, targetValue]) => { if (totalTargets.hasOwnProperty(targetKey) && targetValue > 0) { totalTargets[targetKey] += targetValue; totalCounts[targetKey] = (totalCounts[targetKey] || 0) + 1; } }); }
                      });

                      if ([26, 27, 24, 29, 21, 30, 25, 20, 28, 22, 23, 120].includes(row.sub_indicator_id)) { for (const key in totalTargets) { const count = totalCounts?.[key] || 0; if (count > 0) { totalTargets[key] /= count; } } }

                      const isFirstOccurrence = index === 0 || row.indicator_name !== fetchfilteredData1[index - 1].indicator_name;

                      return (
                        <tr key={index}>
                          <td style={{ textAlign: "center" }} className="sticky-col sticky-sno">{index + 1}</td>
                          <td className="sticky-col sticky-indicator">{isFirstOccurrence ? row.indicator_name : ''}</td>
                          <td style={{
                            minWidth: "200px",
                            wordWrap: "break-word",whiteSpace: "normal",
                            textAlign: "left"
                          }} className="sticky-col sticky-subindicator">{row.sub_indicator_name}</td>
                          <td style={{ textAlign: "center" }} className="sticky-col sticky-phase1unit">{row.unit}</td>

                          {mandalName.map((mandal, i) => (
                            <>
                              <td key={`target-2024-2025-${mandal}-${index}`} className="text-right"> {row.mandalData[mandal]?.targets.target_2024_2025} </td>

                              <td key={`target-2025-2026-${mandal}-${index}`} className="text-right"> {row.mandalData[mandal]?.targets.target_2025_2026} </td>

                              <td key={`target-2026-2027-${mandal}-${index}`} className="text-right"> {row.mandalData[mandal]?.targets.target_2026_2027} </td>

                              <td key={`target-2027-2028-${mandal}-${index}`} className="text-right"> {row.mandalData[mandal]?.targets.target_2027_2028} </td>

                              <td key={`target-2028-2029-${mandal}-${index}`} className="text-right"> {row.mandalData[mandal]?.targets.target_2028_2029} </td>
                            </>
                          ))}

                          <td className="text-right">{totalTargets.target_2024_2025.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2025_2026.toFixed(2)}</td> <td className="text-right">{totalTargets.target_2026_2027.toFixed(2)}</td>
                          <td className="text-right">{totalTargets.target_2027_2028.toFixed(2)}</td>
                          <td className="text-right">{totalTargets.target_2028_2029.toFixed(2)}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>


            </div>

          </div>
        </>

        }
      </Container>
    </>
  );
};
export default IndicatorBasedTarget;
